module.exports = __webpack_public_path__ + "img/bottom.aca6621f.svg";